import { render } from "./GalleriesNavigation.vue?vue&type=template&id=0cdd267e&ts=true"
import script from "./GalleriesNavigation.vue?vue&type=script&lang=ts"
export * from "./GalleriesNavigation.vue?vue&type=script&lang=ts"

import "./GalleriesNavigation.vue?vue&type=style&index=0&id=0cdd267e&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__